export default "<p>\r\n  quizviewergame works!\r\n</p>\r\n";